import { memo } from 'react';
import { StepViewComponentProps } from '../../stepDescriptor/types';
import ToolUseProcessSupervisionComponent from './ToolUseProcessSupervisionComponent';

function ToolUseProcessSupervisionViewComponent(props: StepViewComponentProps) {
  return <ToolUseProcessSupervisionComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(ToolUseProcessSupervisionViewComponent);
